import { Injectable } from '@angular/core';

/**
 * FormatHelperService
 *
 * Centralises display-formatting logic shared across utility dashboard
 * components, eliminating the duplicate `display()` method that previously
 * existed in both HomepageComponent and UtilityDashboardComponent.
 */
@Injectable({
  providedIn: 'root',
})
export class FormatHelperService {
  /**
   * Formats a numeric value for display in the dashboard.
   *
   * Rules:
   * - Returns "—" when the whole page is suppressed (`showDashesForToday`)
   * - Returns "—" when the value is null / undefined
   * - Returns "—" when it is today and the value is 0 (no trading yet)
   * - Otherwise returns the value as a string (shows 0 for past dates)
   */
  display(
    value: number | string | null | undefined,
    isToday: boolean,
    showDashesForToday: boolean
  ): string {
    if (showDashesForToday) return '—';
    if (value === null || value === undefined) return '—';

    if (isToday) {
      const num = Number(value);
      if (!isNaN(num) && num === 0) return '—';
    }

    return String(value);
  }
}
